import React from "react";
import Field from "../../../components/Fields/Field";
import MultiSelectControl from "../../../components/Fields/MultiSelectControl";
import { FieldProps } from "../../../components/Fields/Types";
import useSelectListOptions from '../../../components/Hooks/SelectListOptionsHook/useSelectListOptions';
import ProjectUserUpdateModel from "../../../models/ProjectUserUpdateModel";

interface ProjectUserFieldProps extends FieldProps {
    projectUser: ProjectUserUpdateModel
}

const ProjectUserField: React.FC<ProjectUserFieldProps> = ({ labelProps, controlProps, projectUser }) => {
    const Users = useSelectListOptions('api/v1/selectlist/UsersForFunctionalRole?functionalRoleId=' + projectUser.functionalRoleId);

    return (
        <Field {...labelProps}>
            <MultiSelectControl {...controlProps} options={Users} />
        </Field>
    );
}
export default ProjectUserField;